import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Image, Popup } from 'semantic-ui-react';
import RedDot from './images/red-dot.svg'

const SoldDot = () => (
  <Popup trigger={(
    <img src={RedDot} alt='sold' className='sold-dot' />)} >
    <Popup.Content>
      SOLD
  </Popup.Content>
  </Popup>
)

class ArtCard extends Component {


  render() {
    return (
      <div>
        <div>
      {/* <div className='art-card' style={this.props.maxSize}>
        <div className='art-card-image-container' style={this.props.maxSize}> */}
          <Image
            src={this.props.src}
            onClick={this.props.onClick}
            className='art-card-image'
            style={this.props.maxSize}
          />
          {!this.props.sold ? null : (<SoldDot />)}
        </div>
        <br/>
        {/* <p className='card-title'> */}
        {this.props.title}<br />
        {this.props.desc}
        {/* </p> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  maxSize: state.imageMaximums,
});

export default connect(mapStateToProps, null)(ArtCard)


// WEBPACK FOOTER //
// ./src/ArtCard.js